import React from 'react';

const Subhead = ({ className, children }) => {
	return (
		<p
			className={`
				text-xs uppercase font-black text-gray-450 mb-1
				${className ?? ''}
			`}
		>
			{children}
		</p>
	);
};

export default Subhead;
